import { Injectable } from '@angular/core';
import { ApiService } from '../../http/api.service';
import { AppealJudgementAccuserMapper } from '../../models-mapper/appeal-judgement/appeal-accuser-item.mapper';
import { AppealJudgementAccuserDetailMapper } from '../../models-mapper/appeal-judgement/appeal-accuser.-detailmapper';
import { InputSearchAppealMapper } from '../../models-mapper/appeal-judgement/input-search-appeal.mapper';
import { InputSearchConferencingMapper } from '../../models-mapper/conferencing/input-search-conferencing.mapper';
import { CreateTempExpressMapper } from '../../models-mapper/express/create-temp.mapper';
import { CreateTempRefMapper } from '../../models-mapper/lawsuit/ref-create-temp.mapper';
import { InputSearchTestifyMapper } from '../../models-mapper/testify/input-search-testify.mapper';
import { ApiPath } from '../../models/api-path';
import { AccuserAppealListApiModel, AppealCheckGetSuitModel, PositionInSuitApiModel, SuitCoopApiModel } from '../../models/appeal-judgement/appeal-judgement';
import { VerifyUserDataApiModel } from '../../models/auth/token.model';
import { ReturnTempCreateExpressApisModel } from '../../models/express/express';
import { TempCreateResponseModel } from '../../models/lawsuit/lawsuit';
import { NotificationsModel } from '../../models/page.model';
import { AppealShowPaidModel, AppealSuitTypeModel, BlackNumberCaseModel, CalculateModel, CommonModel, CountryModel, CourtFilterModel, CreditCardModel, FinalCaseModel, NationalityModel, P2pModel, QuestionModel, SuitNumberModel, SummaryFdIdModel, ThaidSettingModel } from '../../models/shared/commone.model';
import { FileModel } from '../../models/shared/file.model';
import { DistrictModel, ProvinceModel, SubdistrictModel } from '../../models/users/user-profile.model';
import { AccuserAppealListViewModel, AppealCaseSuitDetailModel, AppealSearchModel, PositionInSuitViewModel, SuitCoopViewModel } from '../../view-models/appeal-judgement';
import { AccuserModel, inputSearchModel, RefinputSearchModel, UserAccuserModel } from '../../view-models/conferencing';
import { TempCreateExpressModel } from '../../view-models/express';
import { TempCreatRefModel } from '../../view-models/lawsuit';
import { VerifyUserDataModel } from '../../view-models/login';
import { UserAccuserMock } from './_mock/mock-accuser copy';
import { AccuserAppealListMock } from './_mock/mock-accuser-list';
import { daysDatalist, monthDatalist } from './_mock/months.const';
import { rednumbercase } from './_mock/msater-rednumber.const';

@Injectable({
  providedIn: 'root'
})
export class CommonService {


  constructor(
    private apiService: ApiService,
    private inputSearchTestifyMapper: InputSearchTestifyMapper,
    private inputSearchConferencingMapper: InputSearchConferencingMapper,
    private createTempExpressMapper: CreateTempExpressMapper,
    private createTempRefMapper: CreateTempRefMapper,
    private appealJudgementAccuserDetailMapper: AppealJudgementAccuserDetailMapper,
    private appealJudgementAccuserMapper: AppealJudgementAccuserMapper,
    private inputSearchAppealMapper: InputSearchAppealMapper,
  ) { }


  async notify(id: number): Promise<NotificationsModel> {
    const result = await this.apiService.get<NotificationsModel>(`/notifications/${id}`);
    return result!;
  }

  async uploadFile(file: File, reqId: number, fdId: number): Promise<FileModel> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('FD_ID', String(fdId));
    formData.append('fileType', '1');
    const fileApiModel = await this.apiService.post<FileModel>(`/shared/upload-request/${reqId}`, formData);
    let fileModel: FileModel = null!;
    // if(fileApiModel){
    //   fileModel = this.mapper.mapFrom(fileApiModel);
    // }
    return fileApiModel!;
  }
  async uploadFileWord(file: File, reqId: number, fdId: number): Promise<FileModel> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('FD_ID', String(fdId));
    formData.append('fileType', '1');
    const fileApiModel = await this.apiService.post<FileModel>(`/shared/upload-request/doc/${reqId}`, formData);
    let fileModel: FileModel = null!;
    // if(fileApiModel){
    //   fileModel = this.mapper.mapFrom(fileApiModel);
    // }
    return fileApiModel!;
  }
  async deleteFile(fileId: number, reqId: number): Promise<boolean> {
    const result = await this.apiService.delete<boolean>(`/shared/upload-request/${fileId}`);
    return result!;
  }
  async getFile(fileId: number): Promise<any> {
    const result = await this.apiService.get<any>(`/shared/upload-request/${fileId}`);
    return result!;
  }


  async getYears(): Promise<Array<CommonModel>> {
    const result = await this.apiService.get<Array<CommonModel>>(`${ApiPath.common.base}/years`);
    return result!;
  }
  async getMockDays(): Promise<number[]> {
    const result = daysDatalist;
    // const result = await this.apiService.get<Array<CommonModel>>(`${ApiPath.common.base}/${year}/months`);
    return result!;
  }
  async getMonts(): Promise<Array<CommonModel>> {
    const result = monthDatalist;
    // const result = await this.apiService.get<Array<CommonModel>>(`${ApiPath.common.base}/${year}/months`);
    return result!;
  }
  async getMockYears(): Promise<number[]> {
    const current = new Date 
    const year = current.getFullYear() //+ 543
    const result:number[]=[]
    for(let i = (year-99.); i < (year-19);i++){
      result.push(i)
    }
    
    result.sort((a, b) => (b > a) ? 1 : -1)
    // const result = await this.apiService.get<Array<CommonModel>>(`${ApiPath.common.base}/${year}/months`);
    return result!;
  }
  async getMockYearsV2(): Promise<number[]> {
    const current = new Date 
    const year = current.getFullYear() //+ 543
    const result:number[]=[]
    for(let i = (year-99.); i < (year-14);i++){
      result.push(i)
    }
    
    result.sort((a, b) => (b > a) ? 1 : -1)
    // const result = await this.apiService.get<Array<CommonModel>>(`${ApiPath.common.base}/${year}/months`);
    return result!;
  }

  async getMockYearsAppeal(): Promise<number[]> {
    const current = new Date 
    const year = current.getFullYear() //+ 543
    const sYear = new Date(2001,0,1).getFullYear()
    const result:number[]=[]
    for(let i = (sYear); i <= (year);i++){
      result.push(i)
    }
    
    result.sort((a, b) => (b > a) ? 1 : -1)
    return result!;
  }
  async getDays(year: number, monthNo: number): Promise<Array<CommonModel>> {
    const result = await this.apiService.get<Array<CommonModel>>(`${ApiPath.common.base}/year/${year}/month/${monthNo}/days`);
    return result!;
  }
  async getAllProvinces(): Promise<Array<ProvinceModel>> {
    // const result = provincesDatalist
    const result = await this.apiService.get<Array<ProvinceModel>>(`${ApiPath.common.base}/provinces`);
    return result!;
  }
  async getAllNationalitys(): Promise<Array<NationalityModel>> {
    const result = await this.apiService.get<Array<NationalityModel>>(`${ApiPath.common.base}/nationalitys`);
    return result!;
  }
  async getAllPrefixs(): Promise<Array<CommonModel>> {
    const result = await this.apiService.get<Array<CommonModel>>(`${ApiPath.common.base}/prefixes`);
    return result!;
  }
  async getAllCountrys(): Promise<Array<CountryModel>> {
    const result = await this.apiService.get<Array<CountryModel>>(`${ApiPath.common.base}/countrys`);
    return result!;
  }
  async getAllQuestions(): Promise<Array<QuestionModel>> {
    const result = await this.apiService.get<Array<QuestionModel>>(`${ApiPath.common.base}/registration/forgot-questions`);
    return result!;
  }

  async getAllDistricts(provinceId: number): Promise<Array<DistrictModel>> {
    // const result = districtsDatalist
    const result = await this.apiService.get<Array<DistrictModel>>(`${ApiPath.common.base}/${provinceId}/districts`);
    return result!;


  }

  async getAllOccupations(): Promise<Array<CommonModel>> {
    // const result = await this.apiService.get<Array<CommonModel>>(`${ApiPath.common.base}/careers`);
    const result = await this.apiService.get<CommonModel[]>(`${ApiPath.common.base}/careers`);
    // return [{
    //   id: 1,
    //   name: 'เกษตรกร'
    // }, {
    //   id: 2,
    //   name: 'ข้าราชการ'
    // }, {
    //   id: 3,
    //   name: 'ค้าขาย'
    // }, {
    //   id: 4,
    //   name: 'พนักงานบริษัท'
    // }]
    return result!;
  }
  async getAllSubdistricts(districtId: number): Promise<Array<SubdistrictModel>> {
    //const result = subDistrictsDatalist
    const result = await this.apiService.get<Array<SubdistrictModel>>(`${ApiPath.common.base}/${districtId}/subdistricts`);
    return result!;
  }
  async getAllCivilCourts(): Promise<Array<CommonModel>> {
    // const result = administrativeCourts
    const result = await this.apiService.get<Array<CommonModel>>(`${ApiPath.common.base}/primary-court`);
    return result!;
  }
  async getAllHighCourts(): Promise<Array<CommonModel>> {
    // const result = administrativeCourts
    const result = await this.apiService.get<Array<CommonModel>>(`${ApiPath.common.base}/advance-court`);
    return result!;
  }

  async getAllAdministrativeCourts(): Promise<Array<CommonModel>> {
    //const result = administrativeCourts
    const result = await this.apiService.get<Array<CommonModel>>(`${ApiPath.common.base}/court`);
    return result!;
  }

  async getAllCourts(): Promise<Array<CourtFilterModel>> {
    //const result = administrativeCourts
    const result = await this.apiService.get<Array<CourtFilterModel>>(`${ApiPath.common.base}/court`);
    result!.unshift({
      id: null!,
      name: "ทั้งหมด",
      courtType: 0
    })
    return result!;
  }

  async getAllSuitType(courtType:number): Promise<Array<BlackNumberCaseModel>> {
    //const result = blacknumbercase
    const result = await this.apiService.get<Array<BlackNumberCaseModel>>(`${ApiPath.common.base}/suit-type/${courtType}`);
    result!.unshift({
      id: null!,
      name: "ทั้งหมด",
      secId: 0,
      suitTypeId: null!,
      suitTypeS: 0,
    })
    return result!;
  }

  async getAllAppealCourts(courtType:number): Promise<Array<CommonModel>> {
    // const result = administrativeCourts
    const request = {courtType}
    const result = await this.apiService.post<Array<CommonModel>>(`${ApiPath.shared.base}/appeal-case/court`,request);
    return result!;
  }

  // async getAllAdministrativeHighCourts(): Promise<Array<CommonModel>> {
  //   const result = administrativeHighCourts
  //   // const result = await this.apiService.get<Array<ProvinceModel>>(`${ApiPath.common.base}/provinces`);
  //   return result!;
  // }

  async getAllBlackNumberCase(): Promise<Array<BlackNumberCaseModel>> {
    //const result = blacknumbercase
    const result = await this.apiService.get<Array<BlackNumberCaseModel>>(`${ApiPath.common.base}/primary/suit-type`);
    return result!;
  }
  async getAllBlackHighNumberCase(): Promise<Array<BlackNumberCaseModel>> {
    //const result = blacknumbercase
    const result = await this.apiService.get<Array<BlackNumberCaseModel>>(`${ApiPath.common.base}/advance/suit-type`);
    return result!;
  }

  async getAppealBlackHighNumberCase(): Promise<Array<BlackNumberCaseModel>> {
    //const result = blacknumbercase
    const result = await this.apiService.get<Array<BlackNumberCaseModel>>(`${ApiPath.common.base}/advance-appeal/suit-type`);
    return result!;
  }

  async getAllRadNumberCase(): Promise<Array<BlackNumberCaseModel>> {
    const result = rednumbercase
    //const result = await this.apiService.get<Array<CommonModel>>(`${ApiPath.common.base}/primary/suit-type`);
    return result!;
  }

  async getAppealSuitType(courtType:number,suitTypeS:number[]): Promise<Array<AppealSuitTypeModel>> {
    const request = {
      courtType,suitTypeS
    }
    //const result = appealSuitType
    const result = await this.apiService.post<Array<AppealSuitTypeModel>>(`${ApiPath.shared.base}/appeal-case/suit-type`,request);
    return result!;
  }

  // async getAllStatusInCase(): Promise<Array<StatusincasesModel>> {
  //   const result = statusincases
  //   return result!;
  // }

  // async getAlladministrativeHighCourts(): Promise<Array<CommonModel>> {
  //   const result = administrativeHighCourts
  //   return result
  // }

  async getAllBlackNumberHighCase(): Promise<Array<BlackNumberCaseModel>> {
    const result = await this.apiService.get<Array<BlackNumberCaseModel>>(`${ApiPath.common.base}/suit-type`);
    // const result = blackNumberHighCase
    return result!;
  }

  async getBlackNumberHighCase(): Promise<Array<BlackNumberCaseModel>> {
    const result = await this.apiService.get<Array<BlackNumberCaseModel>>(`${ApiPath.common.base}/advance/suit-type/all`);
    // const result = blackNumberHighCase
    return result!;
  }

  async getAccusers(c_ID: number, seC_ID: number, reQ_ID: number, suiT_ID: number,suitTypeS:number): Promise<AccuserModel> {
    const request = { c_ID, seC_ID, reQ_ID, suiT_ID,suitTypeS}
    const result = await this.apiService.post<AccuserModel>(`/shared/accuser-list`, request);
    return result!;
  }

  async getAccusersMock(c_ID: number, seC_ID: number, reQ_ID: number, suiT_ID: number): Promise<AccuserModel> {
    const request = { c_ID, seC_ID, reQ_ID, suiT_ID }
    //const result = accuserMock
    const result = await this.apiService.post<AccuserModel>(`${ApiPath.shared.base}/appeal-case/filing-as/list`, request);
    return result!;
  }

  async getAccusersAppeal(fdtId:number,courtType:number,suitTypeS:number[]): Promise<AccuserModel> {
    const request = { fdtId, courtType, suitTypeS }
    const result = AccuserAppealListMock
    //const result = await this.apiService.post<AccuserAppealModel>(`${ApiPath.shared.base}/appeal-case/filing-as/list`, request);
    return this.appealJudgementAccuserMapper.mapForm(result!)
  }

  async getAccusersAppealList(cId:number,secId:number,suitId:number,fdtId:number,suitTypeS:number,courtType:number): Promise<AccuserAppealListViewModel> {
    const request = { cId,secId,suitId,fdtId,suitTypeS,courtType}
    const result = await this.apiService.post<AccuserAppealListApiModel>(`${ApiPath.shared.base}/appeal-case/accuser-list`, request);
    return result!
  }

  async getPositionInSuit(cId:number,secId:number,suitId:number,fdtId:number,courtType:number): Promise<Array<PositionInSuitViewModel>> {
    const request = { cId,secId,suitId,fdtId,courtType }
    const result = await this.apiService.post<Array<PositionInSuitApiModel>>(`${ApiPath.shared.base}/appeal-case/position-in-suit`, request);
    return result!
  }

  async getCoopSuit(cId:number,secId:number,suitId:number,fdtId:number): Promise<SuitCoopViewModel> {
    const request = { cId,secId,suitId,fdtId }
    const result = await this.apiService.post<SuitCoopApiModel>(`${ApiPath.shared.base}/coop-suit`, request);
    return result!
  }
  // async getAllPlaintiffAndAttorneyNumbers(): Promise<Array<CheckboxModel>> {
  //   const result = plaintiffAndAttorneyNumbers
  //   return result;
  // }

  // async getDefendantAndAttorneyNumbers(): Promise<Array<CheckboxModel>> {
  //   const result = defendantAndAttorneyNumbers
  //   return result;
  // }

  async refCheck(item: RefinputSearchModel): Promise<number> {
    const result = await this.apiService.post<number>(`/shared/check-ref`, item);
    return result!;
  }

  async testifyCheck(item: inputSearchModel): Promise<number> {
    const request = this.inputSearchTestifyMapper.mapTo(item);
    const result = await this.apiService.post<number>(`/shared/check`, request);
    return result!;
  }

  async checkFinalCaseCondition(item: inputSearchModel): Promise<FinalCaseModel> {
    const request = this.inputSearchTestifyMapper.mapTo(item);
    const result = await this.apiService.post<FinalCaseModel>(`/shared/finalCheckDetail002`, request);
    return result!;
  }

  async appealCheck(item: AppealSearchModel): Promise<AppealCheckGetSuitModel> {
    const request = this.inputSearchAppealMapper.mapTo(item);
    const result = await this.apiService.post<AppealCheckGetSuitModel>(`${ApiPath.shared.base}/appeal-case/get-suit`, request);
    return result!;
  }

  async appealPayFeeCheck(item: AppealSearchModel): Promise<AppealCheckGetSuitModel> {
    const request = this.inputSearchAppealMapper.mapTo(item);
    const result = await this.apiService.post<AppealCheckGetSuitModel>(`${ApiPath.shared.base}/appeal-case/get-suit`, request);
    return result!;
  }

  async conferencingCheck(item: inputSearchModel): Promise<number> {
    const request = this.inputSearchConferencingMapper.mapTo(item);
    const result = await this.apiService.post<number>(`/shared/check`, request);
    return result!;
  }
  async createTemp(item: TempCreateExpressModel): Promise<ReturnTempCreateExpressApisModel> {
    const request = this.createTempExpressMapper.mapTo(item);
    const result = await this.apiService.patch<ReturnTempCreateExpressApisModel>(`/shared/temp-request`, request);
    return result!;
  }

  async createRefTemp(item: TempCreatRefModel): Promise<TempCreateResponseModel> {
    const request = this.createTempRefMapper.mapTo(item);
    const result = await this.apiService.patch<TempCreateResponseModel>(`/shared/temp-request-ref`, request);
    return result!;
  }


  async getUserAccuser(c_id: number, sec_id: number, suit_id: number): Promise<UserAccuserModel> {
    const result = await this.apiService.get<UserAccuserModel>(`/shared/court/${c_id}/section/${sec_id}/suit/${suit_id}/accuser/get`);
    return result!;
  }

  async getUserAccuserMock(c_id: number, sec_id: number, suit_id: number): Promise<UserAccuserModel> {
    const result = UserAccuserMock
    return result!;
  }

  async getAppealCaseSuitDetail(cId: number, secId: number, suitId: number,reqId:number): Promise<AppealCaseSuitDetailModel> {
    const request = {cId,secId,suitId,reqId}
    const result = await this.apiService.post<AppealCaseSuitDetailModel>(`${ApiPath.shared.base}/appeal-case/suit-detail`,request);
    return result!;
  }


  async getRefUserAccuser(refCode: string): Promise<UserAccuserModel> {
    const result = await this.apiService.get<UserAccuserModel>(`/shared/${refCode}/accuser/get`);
    return result!;
  }


  async calFree(capp: number): Promise<CalculateModel> {
    const request = {
      suiT_CAPITAL: capp
    }
    const result = await this.apiService.post<CalculateModel>(`${ApiPath.common.base}/calculate/courtfee`, request);
    return result!;
  }

  async forgetUserName(idNo: string, email: string): Promise<any> {
    const request = {
      idNo: idNo,
      email: email
    }
    const result = await this.apiService.post<any>(`${ApiPath.common.base}/forget-username`, request)
    return result!
  }

  async deleteRequest(reqId: number, fdtId: number): Promise<boolean> {
    const result = await this.apiService.delete<boolean>(`/shared/req/${reqId}/foundation-type/${fdtId}`);
    return result!;
  }
  async creditCard(): Promise<CreditCardModel> {
    const result = await this.apiService.get<CreditCardModel>(`${ApiPath.setting.base}/payment/credit-card`);
    return result!;
  }
  async p2p(): Promise<P2pModel> {
    const result = await this.apiService.get<P2pModel>(`${ApiPath.setting.base}/payment/page2page`);
    return result!;
  }

  async sendVerifyEmail(username: string, password: string): Promise<boolean> {
    const request = {
      username: username,
      password: password
    }
    const result = await this.apiService.post<boolean>(`${ApiPath.common.base}/send-confirm-mail`, request)
    return result!
  }

  async verifyEmail(tempId: string, typeVer: string): Promise<VerifyUserDataModel> {
    const queryParam = {
      tempId: tempId,
      typeVer: typeVer
    }
    const result = await this.apiService.get<VerifyUserDataApiModel>(`${ApiPath.common.base}/verify-email/receive`, queryParam)
    return result!
  }

  async activeEmail(tempId: string, username: string): Promise<boolean> {
    const request = {
      tempId: tempId,
      username: username
    }
    const result = await this.apiService.post<boolean>(`${ApiPath.common.base}/active-confirm-email`, request)
    return result!
  }



  pattern = new RegExp('([A-Z]{2})([0-9]{1})-([0-9]{7})-([0-9]{2})');
  public customPatterns = { '0': { pattern: new RegExp('\[A-Z\]') }, '1': { pattern: new RegExp('\[0-9\]') } };

  async checkUserValid(idNo: string, email: string): Promise<any> {
    const request = {
      idNo: idNo,
      email: email
    }
    const result = await this.apiService.post<any>(`${ApiPath.common.base}/check-valid`, request)
    return result!
  }

  async getSuitNumber(reqId:number): Promise<SuitNumberModel> {
    const request = {
      reqId: reqId,
    }
    const result = await this.apiService.post<SuitNumberModel>(`${ApiPath.shared.base}/get-suit-number`, request)
    return result!
  }

  async getSummaryFdId(fdtId:number): Promise<SummaryFdIdModel> {
    const request = {
      fdtId
    }
    const result = await this.apiService.post<SummaryFdIdModel>(`${ApiPath.shared.base}/appeal-case/fdId-doc-upload`, request)
    return result!
  }

  async deleteAppealDraft(cId:number,secId:number,suitId:number,reqId: number): Promise<boolean> {
    const request = {cId,secId,suitId,reqId}
    const result = await this.apiService.delete<boolean>(`${ApiPath.shared.base}/appeal-case/${reqId}/delete`);
    return result!;
  }

  async getAppealDraftDoc(cId:number,secId:number,suitId:number,reqId: number): Promise<FileModel> {
    const request = {cId,secId,suitId,reqId}
    const result = await this.apiService.get<FileModel>(`${ApiPath.shared.base}/appeal-case/draft/${cId}/${secId}/${suitId}/${reqId}/docs`);
    return result!;
  }

  async getAppealSignedDoc(cId:number,secId:number,suitId:number,reqId: number): Promise<FileModel> {
    const request = {cId,secId,suitId,reqId}
    const result = await this.apiService.get<FileModel>(`${ApiPath.shared.base}/appeal-case/signed/${cId}/${secId}/${suitId}/${reqId}/docs`);
    return result!;
  }

  async getAppealShowPaid(cId:number,secId:number,suitId:number,reqId: number): Promise<AppealShowPaidModel> {
    const request = {cId,secId,suitId,reqId}
    const result = await this.apiService.post<AppealShowPaidModel>(`${ApiPath.shared.base}/appeal-case/show-paid`,request);
    return result!;
  }

  async getThaidSetting(): Promise<ThaidSettingModel> {
    const result = await this.apiService.get<ThaidSettingModel>(`${ApiPath.setting.base}/license/thaid`);
    return result!;
  }

  async getThaidUpdateInfoSetting(): Promise<ThaidSettingModel> {
    const result = await this.apiService.get<ThaidSettingModel>(`${ApiPath.setting.base}/license/thaid-updateinfo`);
    return result!;
  }

  async getAppealSuitTypeSecId(courtType:number,suitTypeS:number[],secIdS:number[],chkType:number): Promise<Array<AppealSuitTypeModel>> {
    const request = {
      courtType,suitTypeS,secIdS,chkType
    }
    //const result = appealSuitType
    const result = await this.apiService.post<Array<AppealSuitTypeModel>>(`${ApiPath.shared.base}/appeal-case/suit-type-by-secId`,request);
    return result!;
  }

} 